// extracted by mini-css-extract-plugin
export default {"container":"a--z","list":"b--z"};